// @flow
import React, { PureComponent, Fragment } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';
import { handleTagEvent }from 'utils/tagManagerUtils';
import defaultImgTeam from 'assets/img/logo/placeholder-club.png';
import type { FullUserType } from 'types/User';

export type StateProps = {
  userPref: FullUserType
};

type Props = StateProps & {
  link: string,
  name: string,
  embleme: string,
  saison: string,
  age: string,
};

class CardClubJoueur extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    link: '',
    name: '',
    embleme: '',
    saison: '',
    age: '+18',
  };

  render() {
    const { userPref, link, name, embleme, saison, age } = this.props;
    const image = embleme ? embleme : defaultImgTeam;
    const ContainerClassName = dynamicClassName('box box--white card card--club card--small');
    return (
      <Fragment>
        <p className="block-competition__head ft-h6 ft-up mb-1">
          {saison} {(age === '+18' || age === '+19') ? '' : '('+age+' ans)'}
        </p>
        { link && <Link
          to={link}
          className={ContainerClassName.build()}
          title={`Plus d'information sur ${name}`}
          onClick={handleTagEvent(
            'module club',
            `clic ${name}`,
            window.location.pathname,
            userPref
          )}> 
          <img src={image} alt={name} height="48" width="48" />
          <div className="card__body">
            <div>
              <h4 className="card__title ft-truncat">{name}</h4>
            </div>
          </div>
        </Link> }
        { !link && 
          <div className={ContainerClassName.build()}>
            <img src={image} alt={name} height="48" width="48" />
            <div className="card__body">
              <div>
                <h4 className="card__title ft-truncat">{name}</h4>
              </div>
            </div>
          </div>
        }
      </Fragment>
    );
  }
}

export default CardClubJoueur;
